import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import { EditionBlock, DescribeFloat, RecommendBtn } from '..';

import styles from './index.module.less';

const cx = classnames.bind(styles);

export function Banner() {
  return (
    <EditionBlock
      className={cx('recommend-banner')}
      mainStyle={{
        position: 'relative',
        paddingTop: 150,
      }}>
      <h3>
        <OptimizedImg
          loading="lazy"
          width={507}
          src="https://static.fuxi.netease.com/yaotai/portal/index/liy0m78y_413874.png"
          alt=""
        />
      </h3>
      <h4>
        <span>
          推荐新客用网易瑶台，成单<b>奖励累加</b>无上限！
        </span>
      </h4>
      <div className={cx('banner-operate')}>
        <OptimizedImg
          loading="lazy"
          src="https://static.fuxi.netease.com/yaotai/portal/index/liin2efb_662406.png "
          alt=""
        />
        <span>
          成单即享，单笔奖励最高
          <b> 88888 </b>
          元！
        </span>
      </div>
      <RecommendBtn />
      <DescribeFloat />
    </EditionBlock>
  );
}
